import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum UpsellAnalyticsRecordBillingStatus {
  FREE = "FREE",
  BILLED = "BILLED",
  BILLING_FAILED = "BILLING_FAILED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  PENDING = "PENDING",
}

export enum UpsellAnalyticsRecordBillingKind {
  ONE_CLICK_UPSELL = "ONE_CLICK_UPSELL",
  CONVERSION_CLOUD = "CONVERSION_CLOUD",
}

const _upsellAnalyticsRecordBaseOfferSchema = z.object({
  productGid: z.string(),
  productTitle: z.string(),
  variants: z.array(
    z.object({
      variantGid: z.string(),
      variantTitle: z.string(),
      discount: z
        .object({
          value: z.number(),
          valueType: createEnum(["percentage", "fixed_amount"]),
        })
        .optional(),
    }),
  ),
});
const upsellAnalyticsRecordOfferSchema = z.union([
  _upsellAnalyticsRecordBaseOfferSchema.extend({ accepted: z.literal(false) }),
  _upsellAnalyticsRecordBaseOfferSchema.extend({
    accepted: z.literal(true),
    selectedVariantGid: z.string(),
    upsellRevenue: z.number(),
  }),
]);
export type UpsellAnalyticsRecordOffer = z.infer<
  typeof upsellAnalyticsRecordOfferSchema
>;

export const upsellPageAnalyticsRecordSchema = z.object({
  teamId: zExt.objectId(),
  referenceId: z.string(),
  totalUpsellRevenue: z.number(),
  orderNumber: z.number().optional(),
  billingKind: createEnum(UpsellAnalyticsRecordBillingKind).optional(),
  billingStatus: z.optional(
    z.nullable(createEnum(UpsellAnalyticsRecordBillingStatus)),
  ),
  billingAmountInDollars: z.number().optional(),
  offers: z.array(upsellAnalyticsRecordOfferSchema).optional(),
});
export type UpsellPageAnalyticsRecord = z.infer<
  typeof upsellPageAnalyticsRecordSchema
>;

export const upsellPageAnalyticsRecordDbParser =
  upsellPageAnalyticsRecordSchema.extend({
    _id: zExt.objectId(),
    createdAt: z.date(),
    updatedAt: z.date(),
  });
export type UpsellPageAnalyticsRecordDb = z.infer<
  typeof upsellPageAnalyticsRecordDbParser
>;
